<template>
    <div style="width: 100%;" v-if="pgdata">

        <div style="width:100%;margin: 15px auto auto; background-color: #f9f9f9;">

            <div class="container" style="">
                <div style="padding: 60px 0;">
                    <div class="spacestart alitop">




                        <div style="width: 100%;">
                            <div v-if="pgdata.botnavlist" class="spacestart alitop">
                                <div v-for="it,i in pgdata.botnavlist" :key="i" style="width: 30%;text-align: left;">
                                    <p class="font-weight-bolder" style="font-size: clamp(0.75rem, 0.693rem + 0.28vw, 0.906rem);">
                                        <span v-if="it.type=='txt'">{{it.name}}</span>
                                        <a    v-if="it.type=='link'" style="cursor: pointer;" :href="it.url" :target="it.target">
                                            {{it.name}}
                                        </a>
                                    </p>
                                    <div v-if="it.child" style=" padding: 10px 0 0;font-size: clamp(0.5rem, 0.373rem + 0.64vw, 0.85rem);">
                                        <div v-for="ij,j in it.child" :key="j" style="margin-bottom: 10px;">
                                            <span v-if="ij.type=='txt'">{{ij.name}}</span>
                                            <a    v-if="ij.type=='link'" style="cursor: pointer;" :href="ij.url" :target="ij.target">
                                                {{ij.name}}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="width: 350px;flex-shrink: 0;">
                            <div class="spacestart alicenter">
                                <div style="width: 25px;height: 25px;">
                                    <img src="https://pan.goyoku.com/api/show/pgwk67jw9vv7zq618lziu8vid?w=180" width="100%"/>
                                </div>
                                <div style="margin-left: 10px;">{{pgdata.appname}}</div>
                            </div>
                            <div style="color: #9b9b9b;padding: 5px;font-size:  clamp(0.5rem, 0.373rem + 0.64vw, 0.85rem);">
                                {{pgdata.appsm}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div style="padding: 20px;border-top:1px solid #cccccc;">
            <div  class="container" style="text-align: center;font-size: clamp(.8rem, 0.282rem + .5vw, .7rem);color: #9b9b9b;">
                <div class="d-none d-lg-block d-xl-block">
                    <div class="spacescenter alicenter" style="width: 100%;">
                        <span>Copyright &copy;2017-{{currentYear}}  {{pgdata.copyrigth}}</span>

                        <a v-if="pgdata.beianhao!=''" style="color: #2c3e50;margin:  0 5px 0 10px;" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                            {{pgdata.beianhao}}
                        </a>

                        <div v-if="pgdata.gongwangcode!=''" style="width: 16px; height: 20px;margin:  0 3px 0 10px; flex-shrink: 0;">
                            <img src="../../../static/gwabicon.png" width="100%"/>
                        </div>
                        <a  v-if="pgdata.gongwangcode!=''" style="color: #2c3e50;"
                            :href="'https://beian.mps.gov.cn/#/query/webSearch?code='+pgdata.gongwangcode"
                            target="_blank">
                            {{pgdata.gongwangtxtinfo}}
                        </a>

                    </div>
                </div>


            </div>
            <div class="suidongfontsize" style="font-family:'YouYuan'; width: 100%;text-align: center;padding: 20px;color: #cccccc;">
                每次的回眸微笑将是引领我们前行的那一缕阳光
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "botnav",
        data(){
            return{
                pgdata:null,
            }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        },
        created() {
            if(window.ttdata!=null&&window.ttdata!=undefined&&window.ttdata!='') {
                this.pgdata = window.ttdata;
            }
            //console.log(this.pgdata);
        }
    }
</script>

<style scoped>
    a{
        text-decoration: none;
        color: #3a3a3a;
    }
    .at{
        text-decoration: none;
        color: #545454;
    }

    .suidongfontsize{
        font-size: clamp(0.75rem, 0.568rem + 0.91vw, 1.25rem);
    }
</style>



// WEBPACK FOOTER //
// src/components/comp/botnav.vue